import React, { FunctionComponent } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import styled from "@emotion/styled";
import { theme } from "../../../themes/global";

const LoadingWrapper = styled("div")`
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 1;
  background-color: rgba(51, 51, 51, 0.3);
`;

const Loading: FunctionComponent = () => {
  return (
    <LoadingWrapper>
      <ClipLoader size="35px" />
    </LoadingWrapper>
  );
};

export default Loading;
